import { render, staticRenderFns } from "./MemberPackage.vue?vue&type=template&id=1f04dfe7&scoped=true&"
import script from "./MemberPackage.vue?vue&type=script&lang=js&"
export * from "./MemberPackage.vue?vue&type=script&lang=js&"
import style0 from "./MemberPackage.vue?vue&type=style&index=0&id=1f04dfe7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f04dfe7",
  null
  
)

export default component.exports